export async function getTechnicians() {
  try {
    // Make the API call
    const response = await fetch(
      "https://1xspcrbrk3.execute-api.ap-southeast-1.amazonaws.com/prod/getTechnicians",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check for a successful response
    if (response.ok) {
      const data = await response.json();
      // Sort the technicians by last name alphabetically
      const sortedTechnicians = data.sort((a, b) =>
        a.lastname.localeCompare(b.lastname)
      );
      return sortedTechnicians; // Return the sorted list
    } else {
      console.error(
        `Error: Failed to fetch technicians. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while fetching technicians.",
      error
    );
    return null;
  }
}

// Function to get a specific technician by ID
export async function getTechnician(id) {
  try {
    // Make the API call using the id
    const response = await fetch(
      `https://zyniirabfe.execute-api.ap-southeast-1.amazonaws.com/prod/getTechnician/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check for a successful response
    if (response.ok) {
      const data = await response.json();
      return data; // Return the technician data (assuming it's a single object)
    } else {
      console.error(
        `Error: Failed to fetch technician by id. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while fetching technician by id.",
      error
    );
    return null;
  }
}

export async function postTechnician(technicianParameters = {}) {
  // Construct the payload with spread syntax
  const technicianPayload = {
    ...technicianParameters, // Spread all properties from technicianParameters
  };

  try {
    // Make the API call
    const response = await fetch(
      "https://xs3s1b7g6c.execute-api.ap-southeast-1.amazonaws.com/prod/postTechnician",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(technicianPayload),
      }
    );

    // Check for a successful response
    if (response.ok) {
      return await response.json(); // Return the response as JSON
    } else {
      console.error(
        `Error: Failed to post technician data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while posting technician data.",
      error
    );
    return null;
  }
}

export async function putTechnician(id, technicianParameters = {}) {
  const submitData = {
    ...technicianParameters, // Spread all the properties from jobOrderParameters
  };


  try {
    // Make the API call
    const response = await fetch(
      `https://cw4qt9w772.execute-api.ap-southeast-1.amazonaws.com/prod/putTechnician/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData), // Send technicianPayload directly
      }
    );
    console.log(response);
    // Check for a successful response
    if (response.ok) {
      return await response.json();
    } else {
      console.error(
        `Error: Failed to update technician data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while updating technician data.",
      error
    );
    return null;
  }
}

export async function getCacheTechnicians() {
  try {
    // Make the API call
    const response = await fetch(
      "https://3mdk5os5c7.execute-api.ap-southeast-1.amazonaws.com/prod/getCacheTechnicians",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check for a successful response
    if (response.ok) {
      const data = await response.json();
      // Sort the cache technicians by name alphabetically
      const sortedTechnicians = data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      return sortedTechnicians; // Return the sorted list
    } else {
      console.error(
        `Error: Failed to fetch cache technicians. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while fetching cache technicians.",
      error
    );
    return null;
  }
}

export async function putCacheTechnician(id, cacheTechnicianParameters = {}) {
  // Prepare the data to be submitted
  const submitData = {
    ...cacheTechnicianParameters, // Spread all the properties from cacheTechnicianParameters
  };

  try {
    // Make the API call
    const response = await fetch(
      `https://d23dwd2o40.execute-api.ap-southeast-1.amazonaws.com/prod/putCacheTechnician/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData), // Send submitData directly
      }
    );

    console.log("API Response:", response);

    // Check for a successful response
    if (response.ok) {
      return await response.json(); // Parse and return the JSON response
    } else {
      console.error(
        `Error: Failed to update cache technician data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while updating cache technician data.",
      error
    );
    return null;
  }
}

export async function deleteTechnician(id, technicianParameters = {}) {
  const submitData = {
    ...technicianParameters, // Spread all the properties from jobOrderParameters
  };

  console.log(id);
  console.log(technicianParameters);

  try {
    // Make the API call
    const response = await fetch(
      `https://5cjvlz9dwi.execute-api.ap-southeast-1.amazonaws.com/prod/deleteTechnician/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      }
    );
    console.log(response);
    // Check for a successful response
    if (response.ok) {
      return await response.json();
    } else {
      console.error(
        `Error: Failed to delete technician data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while deleting technician data.",
      error
    );
    return null;
  }
}
